// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zLge","colBig":"styles_colBig__35h1f","colSmall":"styles_colSmall__19VrA"};